import { useAdminStore } from '../../store/adminStore';
import './AdminHeader.css';

export default function AdminHeader() {
    const activePanel = useAdminStore(state => state.activePanel);

    const getPanelTitle = () => {
        const titles = {
            dashboard: 'Dashboard Overview',
            orders: 'Order Management',
            transactions: 'Transaction Monitoring',
            wallets: 'Wallet Management',
            settings: 'System Settings',
        };
        return titles[activePanel];
    };

    return (
        <div className="admin-header glass">
            <div className="header-content">
                <h1 className="header-title">{getPanelTitle()}</h1>
                <div className="header-actions">
                    <div className="status-indicator">
                        <span className="status-dot"></span>
                        <span className="status-text">System Online</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
